import { useQuery } from '@tanstack/react-query';

import { fetchData } from '..';

export type Sender = {
  IsDefault?: boolean;
  MarketingEmailSenderId?: number;
  MetaSender: string;
  SenderEmail: string;
};

export type ControlInfo = {
  IsEnabled?: boolean;
  SendGridAccountKey?: string;
};

type SendersResponse = {
  AllSenders: Sender[];
  ControlInfo?: ControlInfo;
  DefaultSender: Sender;
};

export const SendersQueryKey = ['senders'];

export function useGetSendersQuery() {
  return useQuery({
    queryKey: SendersQueryKey,
    queryFn: async () => fetchData<SendersResponse>('api/email-marketing-config/get-senders'),
  });
}
